// extracted by mini-css-extract-plugin
module.exports = {"popupBody":"popupBody--CRcUBKQn","container":"container--DODJfdgr"};